import { IItemsMapper } from '../item-list.mapper';

export class ItemListMapper<T> implements IItemsMapper<T> {
    public getItemsAddedToList(list: T[], initialList: T[]): T[] {
        const initialItemKeyValues = this.toItemKeyValues(initialList);

        return list.filter(item => !initialItemKeyValues.includes(item[this.key]));
    }

    public getItemsRemovedFromList(list: T[], initialList: T[]): T[] {
        const itemKeyValues = this.toItemKeyValues(list);

        return initialList.filter(item => !itemKeyValues.includes(item[this.key]));
    }

    public getItemsUpdatedInListByKey(list: T[], initialList: T[], updateKey: string): T[] {
        return list.filter(item => {
            const initialItem = initialList.find(_item => _item[this.key] === item[this.key]);
            return initialItem && (item?.[updateKey] ?? null) !== (initialItem?.[updateKey] ?? null);
        });
    }

    constructor(key: keyof T) {
        this.key = key as string;
    }

    private readonly key: string;

    private toItemKeyValues(items: T[]): string[] {
        return items.map(item => item[this.key]);
    }
}
